import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/classes.js';
import form from '../forms/classes.js';
import * as types from '../types.js';

const classes = function()
{

	let classes_crud = crud.create({
		addFilter(params) {
			crud.addFilter.call(this, params);
			if (this.filter && JSON.stringify(this.filter).includes('is_disabled'))
				params.append('include_disabled', '1');
		},
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_classes, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_class, ...JSON.parse(id));
		},
		async setDisabled(disabled) {
			const ids = await this.getSelectedIds(['company_id', 'id']);
			if (!ids.length) return notify('Selecione ao menos uma classificação.', 'Classes');
			const action = disabled ? 'Inativar' : 'Ativar';
			ask(`Confirma ${action} ${ids.length} classificação(ões)?`, action, async (answer) => {
				if (answer !== 'Y') return;
				for (const [company_id, id] of ids) {
					const resp = await api.call(api.patch_class, company_id, id, { is_disabled: !!disabled });
					if (resp == null) { notify('Falha ao atualizar classificação.', 'Classes'); return; }
				}
				this.loadPage();
			});
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				name: data.name,
				is_selective: data.is_selective == '1',
				is_disabled: data.is_disabled == '1'
			};
			if (old_data)
				return await api.call(api.update_class, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_class, data.company_id, _record);
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Classe', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador da classe' },
		{ index: 3, field: 'name', label: 'Nome', types: [types.name()], placeholder: '', title: 'Nome da classe' },
		{ index: 8, field: 'is_selective', label: 'Seletiva?', types: [types.opt_bool(), types.datalist()], placeholder: '', title: 'Determina posições possíveis dos produtos?' },
		{ index: 5, field: 'is_disabled', label: 'Inativo', types: [types.opt_bool(), types.datalist()], placeholder: '', title: 'Classificação inativa' },
	];

	let operations = [
		{ hash: '#class-disable', label: 'Inativar' },
		{ hash: '#class-enable', label: 'Ativar' },
	];

	router.set('#class-disable', classes_crud.setDisabled.bind(classes_crud, true));
	router.set('#class-enable', classes_crud.setDisabled.bind(classes_crud, false));

	classes_crud.run(
		'classes',
		'Classes',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations,
		[]
	);

};

export default classes;

